module.exports = __webpack_public_path__ + "img/Sibiu_4_kl.f03b7288.jpg";